"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IpisFormElementOption = void 0;
var centralized_zod_1 = require("@ipis/centralized-zod");
var IpisFormElementOption;
(function (IpisFormElementOption) {
    IpisFormElementOption.MultipleChoiceSchema = centralized_zod_1.z.object({
        id: centralized_zod_1.z.string(),
        clientSideId: centralized_zod_1.z.string().uuid().nullable(),
        value: centralized_zod_1.z.string(),
    });
    IpisFormElementOption.ImagePromptSchema = centralized_zod_1.z.object({
        id: centralized_zod_1.z.string(),
        clientSideId: centralized_zod_1.z.string().uuid().nullable(),
        promptText: centralized_zod_1.z.string(),
        required: centralized_zod_1.z.boolean(),
    });
    IpisFormElementOption.Schema = centralized_zod_1.z.union([IpisFormElementOption.MultipleChoiceSchema, IpisFormElementOption.ImagePromptSchema]);
})(IpisFormElementOption = exports.IpisFormElementOption || (exports.IpisFormElementOption = {}));
